import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import ServiceForm from '../components/ServiceForm';
import useServices from '../useServices';

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchService, updateService } = useServices();
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [fetchingData, setFetchingData] = useState(true);

  useEffect(() => {
    const loadService = async () => {
      const data = await fetchService(id);
      setInitialData(data);
      setFetchingData(false);
    };
    loadService();
  }, [id, fetchService]);

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const result = await updateService(id, data);
      if (result) {
        navigate('../');
      }
    } finally {
      setLoading(false);
    }
  };

  if (fetchingData) {
    return <Spin />;
  }

  return (
    <ServiceForm
      initialData={initialData}
      onSubmit={handleSubmit}
      loading={loading}
    />
  );
};

export default Edit;